export const Robot = (props: { className?: string }) => {
  return (
    <svg
      width="24"
      height="27"
      viewBox="0 0 24 27"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5301 22.16C20.8501 20.6465 17.8833 19.7099 14.8201 19.41L7.82012 9.50999L14.8201 7.15999C15.0755 8.4978 15.7109 9.73373 16.6501 10.72L17.0201 11.07L23.1601 9.99999L22.8101 7.99999L17.7501 8.89999C17.1128 8.05878 16.7623 7.03527 16.7501 5.97999C16.7672 4.92556 17.1172 3.90351 17.7501 3.05999L22.8101 3.95999L23.1601 1.95999L17.0001 0.929993L16.6301 1.27999C15.6458 2.3257 15.0069 3.64885 14.8001 5.06999L6.46012 7.84999C5.12147 6.65869 3.13574 6.55483 1.68012 7.59999C-0.0932657 8.87892 -0.535356 11.3325 0.680124 13.15L5.37012 20.15C3.64178 20.5841 1.98245 21.2573 0.440124 22.15L0.000123602 22.45V27H24.0001V22.45L23.5301 22.16ZM2.34012 12C2.03114 11.5646 1.90908 11.0237 2.00111 10.4978C2.09315 9.97188 2.39164 9.5046 2.83012 9.19999C3.25631 8.90528 3.78352 8.79534 4.29198 8.89515C4.80044 8.99496 5.24697 9.29604 5.53012 9.72999L12.2601 19.23H12.0001C10.4841 19.2286 8.97114 19.3658 7.48012 19.64L2.34012 12ZM2.00012 23.58V25H22.0001V23.58C18.8951 22.0315 15.4699 21.2334 12.0001 21.25C8.52997 21.2297 5.10392 22.0279 2.00012 23.58Z"
      />
    </svg>
  );
};
